import { render, staticRenderFns } from "./PieEcharts.vue?vue&type=template&id=2c27454a&"
import script from "./PieEcharts.vue?vue&type=script&lang=js&"
export * from "./PieEcharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports